<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row class="bradcrumb">
            <router-link :to="{ name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            <span class="child">/ Student Marks Analysis </span>
        </v-row>
        <br />
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-container>
            <v-card outlined>
                <v-card-title class="heading">
                    <span class="headline">Student Mark Analysis</span>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="3">
                            <label>Select Academic Year</label>
                            <v-autocomplete dense outlined v-model="ayselect" :items="aylist" item-text="ay" item-value="id" placeholder="Select Academic Year" return-object @change="clear('AY')"></v-autocomplete>
                        </v-col>
                        <v-col cols="3">
                            <label>Select Semester</label>
                            <v-autocomplete dense outlined v-model="semselect" :items="semlist" item-text="sem" item-value="id" placeholder="Select Semester" return-object @change="callme()"></v-autocomplete>
                        </v-col>
                        <v-col cols="3">
                            <label>Select Exam</label>
                            <v-autocomplete dense outlined v-model="qttypeselect" :items="exam" item-text="examname" item-value="id" placeholder="Select Exam" return-object @change="clear('EXAM')"></v-autocomplete>
                        </v-col>
                        <v-col cols="3">
                            <label>Select Year</label>
                            <v-autocomplete dense outlined v-model="year" :items="year_list" item-text="year" item-value="year_id" placeholder="Select Year" return-object @change="clear('YEAR')"></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <label>Select Department</label>
                            <v-autocomplete dense outlined v-model="deptselect" :items="deptlist" item-text="name" item-value="id" placeholder="Select Department" return-object @change="getDeptPrograms()"></v-autocomplete>
                        </v-col>
                        <v-col cols="3">
                            <label>Select Program</label>
                            <v-autocomplete dense outlined v-model="progSelect" :items="deptprogram_list" item-text="program" item-value="program_id" placeholder="Select Department" @change="getProgramsCourses()"></v-autocomplete>
                        </v-col>
                        <v-col cols="3">
                            <label>Select Subject</label>
                            <v-autocomplete dense outlined v-model="select_coff" :items="program_course_offering_list" item-text="course_name" item-value="coff_id" placeholder="Select Subject" @change="getExamTT()"></v-autocomplete>
                        </v-col>
                    </v-row>
                    <span v-if="exam_tt_list != null">
                        <v-card-title class="heading">
                            <span class="headline">Exam Time Table</span>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-data-table :headers="headers" :items="exam_tt_list" class="mytable">
                            <template v-slot:item.viewResult="{ item }">
                                <v-btn class="button4" @click="getExamResult(item)">View Result</v-btn>
                            </template>
                        </v-data-table>
                    </span>
                </v-card-text>
            </v-card>
            <br />
            <v-card v-if="unit_headers != null">
                <v-card-title class="heading">
                    <span class="headline">Mark Analysis</span>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-btn class="button4" dark color="success" @click="exportTable('resultTable')">Export Result</v-btn>
                </v-card-title>
                <v-card-text>
                    <v-simple-table class="mytable" id="resultTable">
                        <thead>
                            <th>Sr.No.</th>
                            <th>Reg. No.</th>
                            <th>Student Name</th>
                            <th>Seate No.</th>
                            <th>Course Code</th>
                            <th v-for="headers in unit_headers" :key="headers">
                                {{ headers }}
                            </th>
                            <th>Total</th>
                        </thead>
                        <tbody>
                            <tr v-for="(data, index) in unit_marks_details" :key="index">
                                <td><center>{{ index + 1 }}</center></td>
                                <td><center>{{ data.registration_number }}</center></td>
                                <td><center>{{ data.student_name }}</center></td>
                                <td><center>{{ data.seat_no }}</center></td>
                                <td><center>{{ data.crs_code }}</center></td>
                                <td v-for="marks in data.obtained_marks" :key="marks">
                                    <center>{{ marks.marks }}</center>
                                </td>
                                <td><center>{{ data.total }}</center></td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>
            </v-card>
        </v-container>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css";
    export default {
        data: () => ({
            overlay: false,
            snackbar_msg: "",
            snackbar: false,
            color: "",
            ayselect: null,
            aylist: null,
            exam: null,
            semselect: null,
            semlist: null,
            year_list: null,
            qttypeselect: "",
            year: null,
            deptlist: null,
            deptselect: null,
            program_list: null,
            deptprogram_list: null,
            progSelect: null,
            program_course_offering_list: null,
            select_coff: null,
            exam_tt_list: null,
            unit_headers: null,
            unit_marks_details: null,
            headers: [
                { text: "Exam", value: "exam" },
                { text: "Exam Date", value: "examdate" },
                { text: "Exam Slot", value: "examslot" },
                { text: "View Result", value: "viewResult" },
            ],
        }),
        computed: {},
        mounted() {
            this.overlay = true;
            axios
                .post("/TestCode/viewExamCourse")
                .then((res) => {
                    if (res.data.msg == "200") {
                        console.log(res.data.course_list);
                        this.year_list = res.data.year_list;
                        this.deptlist = res.data.department_list;
                        this.aylist = res.data.academicyearlist;
                        this.semlist = res.data.semesterlist;
                        this.program_list = res.data.program_list;
                        this.course_list = res.data.course_list;
                        this.ayselect = res.data.current_ay
                        this.semselect = res.data.current_semester
                        this.qttypeselect = res.data.current_exam
                        this.exam = res.data.exam_list
                        //this.qttypeselect = res.data.exams_current_id
                        this.overlay = false;
                    } else {
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                });
            //this.unitwisedata()
        },
        methods: {
            callme() {
                this.overlay = true;
                this.year = null;
                this.qttypeselect = null;
                this.exam = null;
                this.deptselect = null;
                this.progSelect = null;
                this.deptprogram_list = null;
                this.select_coff = null;
                this.program_course_offering_list = null;
                this.exam_tt_list = null;
                this.unit_headers = null;
                this.unit_marks_details = null;
                if (this.ayselect == null) {
                    this.showSnackbar("#b71c1c", "Please Select Academic Year!!!");
                    return;
                }
                const data = {
                    ayid: this.ayselect.ayid,
                    semid: this.semselect.semid,
                };
                axios
                    .post("/TestCode/findExam", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.exam = res.data.exam_list;
                            this.overlay = false;
                        } else {
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getDeptPrograms() {
                this.overlay = true;
                this.progSelect = null;
                this.select_coff = null;
                this.program_course_offering_list = null;
                this.exam_tt_list = null;
                this.unit_headers = null;
                this.unit_marks_details = null;
                this.deptprogram_list = [];

                for (let index = 0; index < this.program_list.length; index++) {
                    if (this.deptselect.deptid == this.program_list[index].department) {
                        this.deptprogram_list.push(this.program_list[index]);
                    }
                }
                console.log(this.deptprogram_list);
                this.overlay = false;
            },
            getProgramsCourses() {
                this.unit_headers = null;
                this.unit_marks_details = null;
                if (this.ayselect == null) {
                    this.showSnackbar("#b71c1c", "Please Select Academic Year!!!");
                    return;
                }
                if (this.semselect == null) {
                    this.showSnackbar("#b71c1c", "Please Select Semester!!!");
                    return;
                }
                if (this.semselect == null) {
                    this.showSnackbar("#b71c1c", "Please Select Year!!!");
                    return;
                }
                this.overlay = true;
                const data = {
                    ayid: this.ayselect.ayid,
                    semid: this.semselect.semid,
                    progSelect: this.progSelect,
                    year: this.year.year_id,
                };
                axios
                    .post("/TestCode/findCourseOffering", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.program_course_offering_list = res.data.program_course_offering_list;
                            this.overlay = false;
                        } else {
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    });
            },
            getExamTT() {
                this.overlay = true;
                if (this.ayselect == null) {
                    this.showSnackbar("#b71c1c", "Please Select Academic Year!!!");
                    return;
                }
                const data = {
                    coff: this.select_coff,
                    progSelect: this.progSelect,
                    year: this.year.year_id,
                    exam: this.qttypeselect.examid,
                };
                axios
                    .post("/TestCode/findCourseExamTT", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.exam_tt_list = res.data.exam_tt_list;
                            this.overlay = false;
                        } else {
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    });
            },
            getExamResult(item) {
                this.overlay = true;
                if (this.ayselect == null) {
                    this.showSnackbar("#b71c1c", "Please Select Academic Year!!!");
                    return;
                }
                const data = {
                    exam_tt_id: item.exam_tt_id,
                    ayid: this.ayselect.ayid,
                    semid: this.semselect.semid,
                };
                axios
                    .post("/TestCode/findExamTTResult", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.unit_headers = res.data.headers;
                            this.unit_marks_details = res.data.unit_marks_details;
                            this.overlay = false;
                        } else {
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    });
            },
            clear(type) {
                if (type == "AY") {
                    this.semselect = null;
                    this.qttypeselect = null;
                    this.exam = null;
                    this.deptselect = null;
                    this.progSelect = null;
                    this.deptprogram_list = null;
                    this.select_coff = null;
                    this.program_course_offering_list = null;
                    this.exam_tt_list = null;
                    this.unit_headers = null;
                    this.unit_marks_details = null;
                }
                if (type == "YEAR") {
                    this.deptselect = null;
                    this.progSelect = null;
                    this.deptprogram_list = null;
                    this.select_coff = null;
                    this.program_course_offering_list = null;
                    this.exam_tt_list = null;
                    this.unit_headers = null;
                    this.unit_marks_details = null;
                }
                if (type == "EXAM") {
                    this.deptselect = null;
                    this.progSelect = null;
                    this.deptprogram_list = null;
                    this.select_coff = null;
                    this.program_course_offering_list = null;
                    this.exam_tt_list = null;
                    this.unit_headers = null;
                    this.unit_marks_details = null;
                }
                if (type == "DEPT") {
                    this.progSelect = null;
                    this.deptprogram_list = null;
                    this.select_coff = null;
                    this.program_course_offering_list = null;
                    this.exam_tt_list = null;
                    this.unit_headers = null;
                    this.unit_marks_details = null;
                }
                if (type == "PROGRAM") {
                    this.select_coff = null;
                    this.program_course_offering_list = null;
                    this.exam_tt_list = null;
                    this.unit_headers = null;
                    this.unit_marks_details = null;
                }
            },
            exportTable(mytblId) {
                var htmltable = document.getElementById("resultTable");
                var html = htmltable.outerHTML;
                window.open("data:application/vnd.ms-excel," + encodeURIComponent(html));
            },
        },
    };
</script>
<style scoped>
    .mytable /deep/ thead th {
        color: rgb(0, 0, 0) !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
